import { Check } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Label, TextInput, Card, Toast } from "flowbite-react";
import { useStore } from "../../store";


function SubscriptionPage() {
  const uid = useStore((state) => state.uid);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    subscriptionPlan: "",
  });
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async () => {
    const endpoint = `/user/${uid}/subscription`;
    const url = apiUrl + endpoint;
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          subscription_plan: formData.subscriptionPlan,
        }),
      });

      if (response.ok) {
        setToastMessage("Subscription updated successfully!");
        setShowToast(true);
      } else {
        const data = await response.json();
        setToastMessage(`Failed to update subscription: ${data.detail}`);
        setShowToast(true);
      }
    } catch (error) {
      console.error("Error updating subscription:", error);
      setToastMessage("An error occurred while updating the subscription.");
      setShowToast(true);
    }
  };

  const handleDiscard = () => {
    navigate("/home");
  };

  return (
    <div className="flex flex-col items-center p-8 bg-gray-100 min-h-screen">
      <Card className="w-full max-w-lg">
        <h1 className="text-h4 font-bold text-gray-800 mb-6">
          Subscription Information
        </h1>
        <form className="flex flex-col gap-4">
          {/* Subscription Plan Input */}
          <div>
            <Label htmlFor="subscriptionPlan" className="mb-2">
              Subscription Plan
            </Label>
            <TextInput
              id="subscriptionPlan"
              name="subscriptionPlan"
              type="text"
              value={formData.subscriptionPlan}
              onChange={handleChange}
              placeholder="Enter your subscription plan"
              required
            />
          </div>
        </form>

        {/* Buttons */}
        <div className="flex justify-end gap-4 mt-6">
          <Button color="gray" onClick={handleDiscard}>
            Discard Changes
          </Button>
          <Button color="purple" onClick={handleSave}>
            Save
          </Button>
        </div>
      </Card>

      {showToast && (
        <div className="fixed inset-0 flex items-center justify-center">
          <Toast>
            <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-green-100 text-green-500">
              <Check className="h-5 w-5" />
            </div>
            <div className="ml-3 text-small font-normal">{toastMessage}</div>
            <Toast.Toggle onClick={() => setShowToast(false)} />
          </Toast>
        </div>
      )}
    </div>
  );
}

export default SubscriptionPage;
